<template>
  <div>
    <div :class="['px-4 pa-2', lineCount > 3 && !isShowMore ? 'ellipsis-block' : '']" v-html="text"></div>
    <div class="d-flex pb-2 px-4" v-if="lineCount > 3">
      <span v-show="!isShowMore">......</span>
      <v-btn
        class="ml-auto text-lowercase"
        color="accent"
        @click="isShowMore = !isShowMore"
        :outlined="isShowMore"
        x-small
        rounded
      >
        {{ isShowMore ? "hide" : "more" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextBoxInfo",
  props: {
    text: {
      type: String
    }
  },
  data() {
    return {
      isShowMore: false
    };
  },
  computed: {
    lineCount() {
      const dataStr = this.text;

      return [...dataStr.match(/<p>/g)].length;
    }
  }
};
</script>

<style lang="scss" scoped>
.ellipsis-block {
  overflow-y: hidden;
  max-height: 80px;
}
</style>
